import { JSONSchemaType } from 'ajv'

export interface ICadastralPositionFormData {
  lineHeader: string
  lineHeaderSize: string
  primaryColumn: string
}

export interface ICadastralPositionFileFormData {
  fileForm: ICadastralPositionFormData[]
}

const CadastralPositionSchema: JSONSchemaType<ICadastralPositionFileFormData> = {
  type: 'object',
  properties: {
    fileForm: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          lineHeader: {
            type: 'string',
            minLength: 1,
            errorMessage: 'O campo lineHeader é obrigatório.',
          },
          lineHeaderSize: {
            type: 'string',
            minLength: 1,
            errorMessage: 'O campo lineHeaderSize é obrigatório.',
          },
          primaryColumn: {
            type: 'string',
            minLength: 1,
            errorMessage: 'O campo primaryColumn é obrigatório.',
          },
        },
        required: ['lineHeader', 'lineHeaderSize', 'primaryColumn'],
      },
    },
  },
  required: ['fileForm'],
  additionalProperties: false,
}

export default CadastralPositionSchema
